import { BooleanFilterOperationType } from 'components/organisms/tasks/filters/boolean';
import { DateFieldFilterOperationType } from 'components/organisms/tasks/filters/date';
import { NumberFilterOperationType } from 'components/organisms/tasks/filters/number';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { TextFieldFilterOperationType } from 'components/organisms/tasks/filters/text';

export const BooleanFiltertoHandlebarOperatorsMap = {
  [BooleanFilterOperationType.IsTrue]: 'isTrue',
  [BooleanFilterOperationType.IsFalse]: 'isFalse',
  [BooleanFilterOperationType.IsEmpty]: 'isEmpty',
  [BooleanFilterOperationType.IsNotEmpty]: 'isNotEmpty',
};

export const NumberFiltertoHandlebarOperatorsMap = {
  [NumberFilterOperationType.IsGreaterThan]: 'gt',
  [NumberFilterOperationType.IsLessThan]: 'lt',
  [NumberFilterOperationType.IsEmpty]: 'isEmpty',
  [NumberFilterOperationType.IsNotEmpty]: 'isNotEmpty',
  [NumberFilterOperationType.Is]: 'eq',
};

export const TextFieldFiltertoHandlebarOperatorsMap = {
  [TextFieldFilterOperationType.Contains]: 'contains',
  [TextFieldFilterOperationType.DoesNotContain]: 'notContains',
  [TextFieldFilterOperationType.IsEmpty]: 'isEmpty',
  [TextFieldFilterOperationType.IsNotEmpty]: 'isNotEmpty',
};

export const DateFieldFiltertoHandlebarOperatorsMap = {
  [DateFieldFilterOperationType.IsBeforeToday]: 'isBeforeToday',
  [DateFieldFilterOperationType.IsToday]: 'isToday',
  [DateFieldFilterOperationType.IsTomorrow]: 'isTomorrow',
  [DateFieldFilterOperationType.IsThisWeek]: 'isThisWeek',
  [DateFieldFilterOperationType.IsLastWeek]: 'isLastWeek',
  [DateFieldFilterOperationType.IsNextWeek]: 'isNextWeek',
  [DateFieldFilterOperationType.IsThisMonth]: 'isThisMonth',
  [DateFieldFilterOperationType.IsLastMonth]: 'isLastMonth',
  [DateFieldFilterOperationType.IsThisQuarter]: 'isThisQuarter',
  [DateFieldFilterOperationType.IsLastQuarter]: 'isLastQuarter',
  [DateFieldFilterOperationType.IsThisYear]: 'isThisYear',
  [DateFieldFilterOperationType.IsAfter]: 'isAfter',
  [DateFieldFilterOperationType.IsOn]: 'isOn',
  [DateFieldFilterOperationType.IsBefore]: 'isBefore',
  [DateFieldFilterOperationType.IsEmpty]: 'isEmpty',
  [DateFieldFilterOperationType.IsNotEmpty]: 'isNotEmpty',
};

export const SelectFiltertoHandlebarOperatorsMap = {
  [SelectFilterOperationType.Is]: 'isExactly',
  [SelectFilterOperationType.IsEmpty]: 'isEmpty',
  [SelectFilterOperationType.IsNoneOf]: 'isNoneOf',
  [SelectFilterOperationType.IsNot]: 'isNot',
  [SelectFilterOperationType.IsNotEmpty]: 'isNotEmpty',
  [SelectFilterOperationType.IsOneOf]: 'isOneOf',
};
